// 地图图标
const deviceMapImg = [{
    img: `url(${require("../assets/设备1.png")})`,
    deviceType: "高标准"
}, {
    img: `url(${require("../assets/设备2.png")})`,
    deviceType: "N9500"
}, {
    img: `url(${require("../assets/设备3.png")})`,
    deviceType: "NS400"
}]
//天地图图标使用
const tiandiDeviceMapImg = [{
    img: require("../assets/设备1.png"),
    deviceType: "高标准"
}, {
    img: require("../assets/设备2.png"),
    deviceType: "N9500"
}, {
    img: require("../assets/设备3.png"),
    deviceType: "NS400"
}, {
    img: require("../assets/LpWAN.png"),
    deviceType: "LpWAN基站"
}, {
    img: require("../assets/LpWAN.png"),
    deviceType: "LpWAN终端"
}]

let baseEncoderInfo = {
    Address: '',
    NumberCode: '',
    AlarmState: 2,
    AlarmText: '离线',
    AlarmTime: 0,
    Image: '',
    LandName: '',
    ModelName: '',
    Longitude: 0.0,
    Latitude: 0.0,
    Person: '',
    Phone: '',
    InstallDate: 0,
    Installed: false
}
// 二级菜单左侧菜单栏
const deviceTypeList = [{
    ...baseEncoderInfo,
    EncoderId: 'HS01',
    EncoderName: '农田气象要素监测仪',
    SN: 'HS01',
    InternalModel: 'air',
    code: '气象',
    path: `/encoder/air/`
    

},
{
    ...baseEncoderInfo,
    EncoderId: 'HS02',
    EncoderName: '土壤多参数自动监测站',
    SN: 'HS02',
    InternalModel: 'soil',
    code: '土壤',
    path: `/encoder/soil/`
},
{
    ...baseEncoderInfo,
    EncoderId: 'NC100',
    EncoderName: '农时农情农事观测站',
    SN: 'NC100',
    InternalModel: 'camera',
    code: '摄像机',
    path: `/encoder/camera/`
},
// {
//     ...baseEncoderInfo,
//     EncoderId: 'HS03',
//     EncoderName: '智能感知监测站',
//     SN: 'HS03',
//     InternalModel: 'sense'
// }
    // ,
    // {
    //     ...baseEncoderInfo,
    //     EncoderId: 'HS06',
    //     EncoderName: '虫情测报灯',
    //     SN: 'HS06',
    //     InternalModel: 'pest'
    // }
    // , {
    //     ...baseEncoderInfo,
    //     EncoderId: 'HS07',
    //     EncoderName: '害虫性诱智能监测',
    //     SN: 'HS07',
    //     InternalModel: 'sexual'
    // }
]

// 土壤参数表
const soilParamList = [
    { key: "conductivity20CM", label: "电导率20CM深度", unit: "mS/cm", Resource: 129 },
    { key: "conductivity40CM", label: "电导率40CM深度", unit: "mS/cm", Resource: 156 },
    { key: "conductivity60CM", label: "电导率60CM深度", unit: "mS/cm", Resource: 161 },
    { key: "conductivity80CM", label: "电导率80CM深度", unit: "mS/cm", Resource: 166 },

    { key: "moisture20CM", label: "湿度20CM深度", unit: "%", Resource: 126 },
    { key: "moisture40CM", label: "湿度40CM深度", unit: "%", Resource: 153 },
    { key: "moisture60CM", label: "湿度60CM深度", unit: "%", Resource: 158 },
    { key: "moisture80CM", label: "湿度80CM深度", unit: "%", Resource: 163 },

    { key: "temperature20CM", label: "温度20CM深度", unit: "℃", Resource: 125 },
    { key: "temperature40CM", label: "温度40CM深度", unit: "℃", Resource: 152 },
    { key: "temperature60CM", label: "温度60CM深度", unit: "℃", Resource: 157 },
    { key: "temperature80CM", label: "温度80CM深度", unit: "℃", Resource: 162 },

    { key: "salinity", label: "土壤盐分", unit: "us/cm", Resource: 162 },

    { key: "ph", label: "pH", unit: "", Resource: 164 },
]
// 土壤参数表
const soilParamList1 = [
    { key: "conductivity20CM", label: "电导率20CM深度", unit: "mS/cm", Resource: 129 },
    { key: "conductivity40CM", label: "电导率40CM深度", unit: "mS/cm", Resource: 156 },
    { key: "conductivity60CM", label: "电导率60CM深度", unit: "mS/cm", Resource: 161 },
    { key: "conductivity80CM", label: "电导率80CM深度", unit: "mS/cm", Resource: 166 },

    { key: "moisture20CM", label: "湿度20CM深度", unit: "%", Resource: 126 },
    { key: "moisture40CM", label: "湿度40CM深度", unit: "%", Resource: 153 },
    { key: "moisture60CM", label: "湿度60CM深度", unit: "%", Resource: 158 },
    { key: "moisture80CM", label: "湿度80CM深度", unit: "%", Resource: 163 },

    { key: "temperature20CM", label: "温度20CM深度", unit: "℃", Resource: 125 },
    { key: "temperature40CM", label: "温度40CM深度", unit: "℃", Resource: 152 },
    { key: "temperature60CM", label: "温度60CM深度", unit: "℃", Resource: 157 },
    { key: "temperature80CM", label: "温度80CM深度", unit: "℃", Resource: 162 },

    { key: "salinity", label: "土壤盐分", unit: "us/cm", Resource: 162 },

    { key: "ph", label: "pH", unit: "", Resource: 164 },
]
// 土壤参数表
const soilParamList3 = [
    // { key: "conductivity20CM", label: "电导率20CM深度", unit: "mS/cm", Resource: 129 },
    // { key: "conductivity40CM", label: "电导率40CM深度", unit: "mS/cm", Resource: 156 },
    // { key: "conductivity60CM", label: "电导率60CM深度", unit: "mS/cm", Resource: 161 },
    // { key: "conductivity80CM", label: "电导率80CM深度", unit: "mS/cm", Resource: 166 },

    // { key: "moisture20CM", label: "湿度20CM深度", unit: "%", Resource: 126 },
    // { key: "moisture40CM", label: "湿度40CM深度", unit: "%", Resource: 153 },
    // { key: "moisture60CM", label: "湿度60CM深度", unit: "%", Resource: 158 },
    // { key: "moisture80CM", label: "湿度80CM深度", unit: "%", Resource: 163 },

    // { key: "temperature20CM", label: "温度20CM深度", unit: "℃", Resource: 125 },
    // { key: "temperature40CM", label: "温度40CM深度", unit: "℃", Resource: 152 },
    // { key: "temperature60CM", label: "温度60CM深度", unit: "℃", Resource: 157 },
    // { key: "temperature80CM", label: "温度80CM深度", unit: "℃", Resource: 162 },

    { key: "salinity", label: "土壤盐分", unit: "mg/L", Resource: 162 },

    { key: "ph", label: "pH", unit: "", Resource: 164 },
]

// 土壤人工检测参数表
const soilParamList2 = [
    { key: "validP", label: "有效磷", unit: "mg/kg", Resource: 11 },
    { key: "fullN", label: "全氮", unit: "g/kg", Resource: 11 },
    { key: "fastK", label: "速效钾", unit: "mg/kg", Resource: 11 },
    { key: "soilPH", label: "土壤pH值", unit: "", Resource: 11 },
    { key: "organicMatter", label: "有机质含量", unit: "g/kg", Resource: 11 },
    { key: "bulkDensity", label: "土壤容重", unit: "g/cm³", Resource: 11 },
]
// 气象参数表
const airParamList = [
    { key: "temperature", label: "温度", unit: "℃", Resource: 105 },
    { key: "humidity", label: "湿度", unit: "%", Resource: 106 },
    { key: "pressure", label: "气压", unit: "hPa", Resource: 147 },
    { key: "illuminance", label: "光照", unit: "Klux", Resource: 113 },

    { key: "windGrade", label: "风速", unit: "", Resource: 108 },
    { key: "windDirectionName", label: "风向", unit: "", Resource: 107 },
    { key: "precipitation", label: "雨量", unit: "mm/min", Resource: 109 },

]

//土壤请求参数对照表 temperature-soil, conductivity, moisture, salinity
// 土壤详情左侧参数表
const soilDetailList = [
    {
        to: {
            name: 'soilsensor',
            params: {
                // id: this.EncoderId,
                group: 'temperature',
                type: "temperature",
                queryParam: "temperature-soil",
                valueParam: ["temperature20CM", "temperature40CM", "temperature60CM", "temperature80CM"]
            }
        },
        icon: 's-125',
        name: '土壤温度',
        sid: 125
    },
    {
        to: {
            name: 'soilsensor',
            params: {
                // id: this.EncoderId,
                group: 'humidity',
                type: "moisture",
                queryParam: "moisture",
                valueParam: ["moisture20CM", "moisture40CM", "moisture60CM", "moisture80CM"]
            }
        },
        icon: 's-126',
        name: '土壤湿度',
        sid: 126
    },
    {
        to: {
            name: 'soilsensor',
            params: {
                ///  id: this.EncoderId,
                group: 'salinity',
                type: "salinity",
                queryParam: "salinity",
                valueParam: ['salinity']
            }
        },
        icon: 's-128',
        name: '土壤盐分',
        sid: 128
    },
    {
        to: {
            name: 'soilsensor',
            params: {
                ///id: this.EncoderId, 
                group: 'pH',
                type: 'ph',
                queryParam: "ph-soil",
                valueParam: ["ph"]
            }
        },
        icon: 's-127',
        name: '土壤pH',
        sid: 127
    },
    {
        to: {
            name: 'soilsensor',
            params: {
                // id: this.EncoderId,
                group: 'conductivity',
                type: "conductivity",
                queryParam: "conductivity-soil",
                valueParam: ["conductivity20CM", "conductivity40CM", "conductivity60CM", "conductivity80CM"]
            }
        },
        icon: 's-129',
        name: '土壤电导率',
        sid: 129
    }
]

//气象：temperature-air,humidity,pressure,illuminance,windSpeed,windDirection,precipitation.    
//气象详情左侧参数表
const airDetailList = [{
    "to": {
        "name": "airsensor",
        "params": {
            "id": "",
            "sid": "3871",
            type: "windSpeed",
            queryParam: "windSpeed",
            valueParam: ['windSpeed']
        }
    },
    "icon": "s-108",
    "name": "风速",
    "sid": "3871",
    unit: "级",
}, {
    "to": {
        "name": "airsensor",
        "params": {
            "id": "",
            "sid": "3872",
            type: "windDirection",
            queryParam: "windDirection",
            valueParam: ["windDirection"]
        }
    },
    "icon": "s-107",
    "name": "风向",
    "sid": "3872",
    unit: "度",
}, {
    "to": {
        "name": "airsensor",
        "params": {
            "id": "",
            "sid": "3870",
            type: "temperature",
            queryParam: "temperature-air",
            valueParam: ["temperature"]
        }
    },
    "icon": "s-105",
    "name": "空气温度",
    "sid": "3870",
    unit: "℃",
}, {
    "to": {
        "name": "airsensor",
        "params": {
            "id": "",
            "sid": "3868",
            type: "humidity",
            queryParam: "humidity",
            valueParam: ["humidity"]
        }
    },
    "icon": "s-106",
    "name": "空气湿度",
    "sid": "3868",
    unit: "%"
}, {
    "to": {
        "name": "airsensor",
        "params": {
            "id": "",
            "sid": "3875",
            type: "precipitation",
            queryParam: "precipitation",
            valueParam: ["precipitation"]
        }
    },
    "icon": "s-109",
    "name": "雨量",
    "sid": "3875",
    unit: "mm/min"
}, {
    "to": {
        "name": "airsensor",
        "params": {
            "id": "",
            "sid": "3869",
            type: "illuminance",
            queryParam: "illuminance",
            valueParam: ["illuminance"]
        }
    },
    "icon": "s-113",
    "name": "光照强度",
    "sid": "3869",
    unit: "Klux"
}, {
    "to": {
        "name": "airsensor",
        "params": {
            "id": "",
            "sid": "3873",
            type: "pressure",
            queryParam: "pressure",
            valueParam: ["pressure"]
        }
    },
    "icon": "s-147",
    "name": "大气压",
    "sid": "3873",
    unit: "hPa"
},
{
    showIcon: true,
},
{
    "to": {
        "name": "airsensor",
        "params": {
            "id": "",
            "sid": "3871",
            type: "accumulated-temperature",
            queryParam: "accumulated-temperature",
            valueParam: []
        }
    },
    "icon": "s-105",
    "name": "积温",
    "sid": "3871"
}, {
    "to": {
        "name": "airsensor",
        "params": {
            "id": "",
            "sid": "3872",
            type: "accumulated-rainfall",
            queryParam: "accumulated-rainfall",
            valueParam: []
        }
    },
    "icon": "s-109",
    "name": "累计降雨量",
    "sid": "3872"
}
]
const jiangsuprovinceList = [
    {
        city: "南京",
        color: "red",
        adcode:"320100",
        key: 1,
        zoom: 9.61,
        center: [118.890232, 31.953877],
        childList: [
            { city: "玄武区", adcode: "320102","center" :"118.797779,32.048644", },
            { city: "秦淮区", adcode: "320104","center" :"118.794792,32.039065", },
            { city: "建邺区", adcode: "320105","center" :"118.731642,32.003343", },
            { city: "鼓楼区", adcode: "320106", "center" :"118.769943,32.066814",},
            { city: "浦口区", adcode: "320111" ,"center" :"118.627165,32.059796",},
            { city: "栖霞区", adcode: "320113" ,"center" :"118.909117,32.096423",},
            { city: "雨花台区", adcode: "320114","center" :"118.779087,31.991291", },
            { city: "江宁区", adcode: "320115","center" :"118.83951,31.953195",},
            { city: "六合区", adcode: "320116" ,"center" :"118.822241,32.323235",},
            { city: "溧水区", adcode: "320117","center" :"119.028414,31.651108", },
            { city: "高淳区", adcode: "320118","center" :"118.892074,31.328678", }
        ]
    },
    {
        city: "常州",
        color: "green",
        key: 2,
        zoom: 10.28,
        adcode:"320400",
        center: [119.736638, 31.640658],
        childList: [
            { city: "金坛区", adcode: "320413","center" :"119.587503,31.722384",},
            { city: "天宁区", adcode: "320402","center" :"119.999439,31.79232", },
            { city: "钟楼区", adcode: "320404", "center" :"119.902081,31.802608",},
            { city: "新北区", adcode: "320411", "center" :"119.960925,31.86355",},
            { city: "武进区", adcode: "320412", "center" :"119.942441,31.701252",},
            { city: "溧阳市", adcode: "320481", "center" :"119.484164,31.416967",}]
    },
    {
        city: "镇江",
        key: 3,
        color: "yellow",
        adcode:"321100",
        zoom: 10.5,
        center: [119.525067, 31.966169],
        childList: [
            { city: "京口区", adcode: "321102","center" :"119.470186,32.198285", },
            { city: "润州区", adcode: "321111" ,"center" :"119.411383,32.195146",},
            { city: "丹徒区", adcode: "321112","center" :"119.433854,32.132118", },
            { city: "丹阳市", adcode: "321181","center" :"119.606071,32.010035", },
            { city: "扬中市", adcode: "321182","center" :"119.796816,32.236476", },
            { city: "句容市", adcode: "321183", "center" :"119.168693,31.945732",}
        ]
    },
    {
        city: "扬州",
        key: 4,
        color: "green",
        zoom: 9.82,
        adcode:"321000",
        center: [119.636491, 32.816918],
        childList: [
            { city: "邗江区", adcode: "321003","center" :"119.397935,32.37741",},
            { city: "广陵区", adcode: "321002", "center" :"119.431785,32.395654",},
            { city: "江都区", adcode: "321012", "center" :"119.569684,32.43571",},
            { city: "高邮市", adcode: "321084", "center" :"119.45892,32.781606",},
            { city: "仪征市", adcode: "321081", "center" :"119.184468,32.272833",},
            { city: "宝应县", adcode: "321023", "center" :"119.358389,33.241125",}]
    },
    {
        city: "无锡",
        color: "blue",
        key: 5,
        adcode:"320200",
        zoom: 10.28,
        center: [120.223444, 31.531318],
        childList: [
            { city: "梁溪区", adcode: "320213","center" :"120.303551,31.566226", },
            { city: "锡山区", adcode: "320205","center" :"120.357732,31.589484", },
            { city: "惠山区", adcode: "320206","center" :"120.29843,31.680282", },
            { city: "滨湖区", adcode: "320211","center" :"120.284381,31.527846", },
            { city: "新吴区", adcode: "320214", "center" :"120.364303,31.49085",},
            { city: "江阴市", adcode: "320281","center" :"120.284794,31.921642", },
            { city: "宜兴市", adcode: "320282","center" :"119.821873,31.338429", }]
    },
    {
        city: "南通",
        color: "yellow",
        zoom: 10.05,
        key: 6,
        adcode:"320600",
        center: [121.010421, 32.216887],
        childList: [
            { city: "崇川区", adcode: "320613" ,"center" :"120.857253,32.010277",},
            { city: "通州区", adcode: "320612", "center" :"121.073742,32.065972",},
            { city: "海门区", adcode: "320614","center" :"121.182016,31.869418",},
            { city: "如东县", adcode: "320623" ,"center" :"121.18495,32.331584",},
            { city: "启东市", adcode: "320681","center" :"121.65523,31.792831", },
            { city: "如皋市", adcode: "320682" ,"center" :"120.574028,32.371493",},
            { city: "海安市", adcode: "320685", "center" :"120.46779,32.532853",}
        ]
    },
    {
        city: "苏州",
        color: "green",
        zoom: 9.84,
        key: 7,
        adcode:"320500",
        center: [120.742398, 31.480627],
        childList: [
            { city: "相城区", adcode: "320507", "center" :"120.642391,31.369189",},
            { city: "姑苏区", adcode: "320508","center" :"120.617367,31.335648",},
            { city: "吴江区", adcode: "320509", "center" :"120.645728,31.138525",},
            { city: "虎丘区", adcode: "320505","center" :"120.434238,31.329601", },
            { city: "吴中区", adcode: "320506","center" :"120.632094,31.263604", },
            { city: "常熟市", adcode: "320581","center" :"120.752512,31.656016", },
            { city: "张家港市", adcode: "320582","center" :"120.555979,31.876739", },
            { city: "太仓市", adcode: "320585" ,"center" :"121.130344,31.458043",},
            { city: "昆山市", adcode: "320583","center" :"120.980795,31.385476", }]
    },
    {
        city: "盐城",
        color: "yellow",
        zoom: 9.15,
        key: 8,
        adcode:"320900",
        center: [120.501007, 33.464291],
        childList: [
            { city: "东台市", adcode: "320981" ,"center" :"120.320308,32.867845",},
            { city: "建湖县", adcode: "320925","center" :"119.788743,33.438931",},
            { city: "射阳县", adcode: "320924","center" :"120.326338,33.766277", },
            { city: "阜宁县", adcode: "320923","center" :"119.802271,33.758857", },
            { city: "滨海县", adcode: "320922", "center" :"119.820713,33.990372",},
            { city: "响水县", adcode: "320921","center" :"119.578332,34.199172", },
            { city: "大丰区", adcode: "320904","center" :"120.500761,33.200047", },
            { city: "亭湖区", adcode: "320902", "center" :"120.196148,33.391414",},
            { city: "盐都区", adcode: "320903", "center" :"120.153567,33.338538",}]
    },
    {
        city: "淮安市",
        color: "red",
        zoom: 9.6,
        key: 9,
        adcode:"320800",
        center: [119.195079, 33.400543],
        childList: [
            { city: "淮安区", adcode: "320803","center" :"119.141183,33.50296", },
            { city: "淮阴区", adcode: "320804","center" :"119.034895,33.632588", },
            { city: "清江浦区", adcode: "320812","center" :"119.026662,33.552579", },
            { city: "洪泽区", adcode: "320813","center" :"118.873132,33.294095", },
            { city: "涟水县", adcode: "320826","center" :"119.260589,33.781648", },
            { city: "盱眙县", adcode: "320830","center" :"118.544545,33.011905", },
            { city: "金湖县", adcode: "320831","center" :"119.020432,33.024663", }
        ]
    },
    {
        city: "宿迁",
        color: "blue",
        zoom: 9.82,
        key: 10,
        adcode:"321300",
        center: [118.774229, 33.823502],
        childList: [
            { city: "沭阳", adcode: "321322","center" :"118.804321,34.110642", },
            { city: "泗阳", adcode: "321323","center" :"118.703636,33.723576", },
            { city: "泗洪", adcode: "321324","center" :"118.223941,33.476575", },
            { city: "宿豫区", adcode: "321311","center" :"118.330423,33.94813", },
            { city: "宿城区", adcode: "321302","center" :"118.242048,33.963891", }
        ]
    },
    {
        city: "连云港",
        color: "red",
        zoom: 10.05,
        key: 11,
        adcode:"320700",
        center: [119.285428, 34.487559],
        childList: [
            { city: "连云区", adcode: "320703", "center" :"119.338901,34.760317", },
            { city: "赣榆区", adcode: "320707","center" :"119.173173,34.841336", },
            { city: "灌南县", adcode: "320724","center" :"119.315583,34.087251", },
            { city: "东海县", adcode: "320722","center" :"118.752869,34.542194", },
            { city: "灌云县", adcode: "320723","center" :"119.239426,34.284074", },
            { city: "海州区", adcode: "320706","center" :"119.163492,34.572506", }]
    },
    {
        city: "徐州",
        color: "green",
        zoom: 9.6,
        key: 12,
        adcode:"320300",
        center: [117.678611, 34.363818],
        //childList: [{ city: "云龙区" }, { city: "鼓楼区" }, { city: "泉山区" }, { city: "贾汪区" }, { city: "铜山区" }]
        childList: [
            { city: "睢宁县", adcode: "320324", "center" :"117.941364,33.913727",},
            { city: "沛县", adcode: "320322","center" :"116.936353,34.760761", },
            { city: "丰县", adcode: "320321", "center" :"116.658111,34.697232",},
            { city: "云龙区", adcode: "320303","center" :"117.251515,34.253638", },
            { city: "鼓楼区", adcode: '320302',"center" :"117.185643,34.288736", },
            { city: "泉山区", adcode: "320311", "center" :"117.194405,34.22655",},
            { city: "贾汪区", adcode: "320305","center" :"117.465137,34.436492", },
            { city: "铜山区", adcode: "320312", "center" :"117.169698,34.181162",},
            { city: "新沂市", adcode: "320381", "center" :"118.354747,34.369585",},
            { city: "邳州市", adcode: "320382","center" :"118.012511,34.339208", }]
    },
    {
        city: "泰州",
        color: "blue",
        zoom: 9.6,
        key: 13,
        adcode:"321200",
        center: [120.305133, 32.599521],
        childList: [
            { city: "泰兴市", adcode: "321283","center" :"120.051475,32.173072", },
            { city: "兴化市", adcode: "321281", "center" :"119.85255,32.911952",},
            { city: "靖江市", adcode: "321282","center" :"120.277124,31.98325", },
            { city: "海陵区", adcode: "321202","center" :"119.923825,32.49248", },
            { city: "高港区", adcode: "321203","center" :"119.88154,32.31923", },
            { city: "姜堰区", adcode: "321204", "center" :"120.12807,32.51029",}]
    },
];





export {
    deviceMapImg,
    deviceTypeList, soilParamList, airParamList,
    soilDetailList, airDetailList, tiandiDeviceMapImg,
    jiangsuprovinceList, soilParamList2, soilParamList1, soilParamList3
}
